import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/rp5.jfif";
import rpd2 from "../../Assets/rpd2.jpg";
import rpd3 from "../../Assets/rpd3.jpg";
import Particle from "../Particle"; 
import Type from "./Type";
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import rp from "../../Assets/rp.png";
import { FaTelegramPlane, FaDiscord, FaTwitter } from "react-icons/fa";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={12} style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <img src={homeLogo} width="100%" className="home-img" alt="home pic"/>
          </Col>
          </Row>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={3}  style={{ justifyContent: "center", paddingBottom: "10px" }}>
              <Button variant="warning" width="100%" href="https://cchain.explorer.avax.network/address/0x61eCd63e42C27415696e10864d70ecEA4aA11289/transactions" target="_blank">
                {"---- VIEW OUR CONTRACT ----"}
              </Button>
            </Col>
          </Row>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <h1 className="home-heading">
              <strong className="gold">BECOME A VERIFIED DETECTIVE</strong>
            </h1>
          </Row>
          <Row>
          <Col md={4}>
            <img src={rpd2} width="100%" className="home-img" alt="home pic"/>
          </Col>
          <Col md={8}>
          <br/>
          <p>
          <span className="home-about-body">
            <strong>Verify Yourself.</strong><br/><br/>
            You can stake our Detective Series NFTs in our Staking Dapp.
          </span>
          </p>
          <br/>
          <p>
          <span className="home-about-body">
          <strong>Help Us Provide Transparency.</strong><br/><br/>
          When you Stake your Detective NFTs, you will receive a non-monetized token called
          TDG (The Detective's Guild). This will be used to verify that you are a part of the
          community. It will allow you to vote, rate and comment on projects in the Detective's
          Guild.
          </span>
          </p>
          <br/>
          </Col>
          <Row >
          </Row>
          <Col md={8} style={{ paddingTop: "70px" }}>
          <p>
          <span className="home-about-body">
          <strong>Join the Detective's Guild Chat.</strong><br/><br/>
          Holding TDG tokens will allow you to participate in our ongoing Detective's Guild
          investigations in our official Discord.
          </span>
          </p>
          <br/>
          </Col>
          <Col md={4}  style={{ paddingTop: "270px" }}>
            <img src={rpd3} width="100%" className="home-img" alt="home pic"/>
          </Col>
          </Row>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <h1 className="home-heading">
              <strong className="gold">Rugpull Prevention NFTs</strong>
            </h1>
          </Row>
          <Row>
          <Col md={4}>
            <img src={rp} width="100%" className="home-img" alt="home pic"/>
          </Col>
          <Col md={8}>
          <br/>
          <p>
          <span className="home-about-body">
            Click here for more info:  
          </span>
          <a className="home-about-body" href="https://enebula.gitbook.io/rugpull-prevention/our-deflationary-staking-dapp/reasons-for-staking-dapp"> https://enebula.gitbook.io/rugpull-prevention/our-deflationary-staking-dapp/reasons-for-staking-dapp</a>
          </p>
          <br/>

          </Col>
          </Row>
        {/* </Row> */}
        <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}></Row>
        </Container>
      </Container>
    </section>
  );
}

export default Home;
